<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">
        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead02">
                <div class="inner4">
                    <h1><img class="" src="/img_report_raytrek/title.png" srcset="/img_report_raytrek/title@2x.png 2x" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            2021年11月3日（水・祝）〜12月11日（土）にオンライン開催された東京カメラ部2021写真展 Online Exhibition「だから、世界は美しい。」。<br>
                            <br>
                            写真展に連動し、協賛団体様のご提供イベント、東京カメラ部の主催者自主企画など数々のオンライントークショーが開催されました。2021年11月14日（日）には、株式会社サードウェーブ 齊藤薫氏、東京カメラ部10選 井上浩輝氏と別所隆弘氏にご出演いただき、クリエイターPC視点「raytrek(レイトレック)のレタッチお悩み解決 Before & Afterご紹介」と題した、レタッチの必要性や基礎を学びたい人に向けたトークが展開されました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            東京カメラ部運営 塚崎（司会）「みなさんこんばんは。東京カメラ部2021写真展 Online Exhibition、株式会社サードウェーブのクリエイターPC視点『raytrek(レイトレック)のレタッチお悩み解決 Before & Afterご紹介』を開始させていただきます。今回はSNSを中心にさまざまな場所でご活躍し、raytrekアンバサダーでもある、東京カメラ部10選の井上浩輝さん、別所隆弘さん、そしてraytrekを展開する株式会社サードウェーブ 齊藤薫さんをお招きしています。まずは簡単に自己紹介をお願いします」<br>
                            <br>
                            別所「関西で花火や飛行機など、風景写真を撮っております。今日はその辺りの話をできればと思っています」<br>
                            <br>
                            井上「写真家の井上浩輝です。僕は動物や自然風景の写真を撮っています。また、広告の写真やムービーを撮るということも最近はやっています。僕はあまり現像をしていないと思われがちなのですが、ゴリゴリとハードな現像や、映像の色彩を補正するカラーコレクションをやったりすることもありますので、その辺のお話をできればと思っています」<br>
                            <br>
                            齊藤「こんばんは。サードウェーブ 齊藤です。よろしくお願いします。」<br>
                            <br>
                            塚崎「本日は写真のレタッチについて、これから始めたいという方や、レタッチはしているものの基礎を改めて学びたいという方におすすめの内容となっているということですよね、齊藤さん」<br>
                            <br>
                            齊藤「はい。井上さん、別所さんの作品のビフォーアフターを見ながら進めてまいります。raytrekの公式Instagramアカウント『raytrek_visual』で実施したハッシュタグキャンペーンにご投稿いただいた作品も交えながら進めていきます。タイトルにもある通り、お悩み解決が中心となりますので、ぜひお気軽にコメントしていただければと思います」<br>
                            <br>
                            塚崎「今回のキャンペーンは、インスタライブ配信記念ということで、レタッチを始めたころの作品に指定のハッシュタグをつけて投稿いただくと、『<a target="_blank" href="https://www.dospara.co.jp/5shopping/detail_prime.php?tg=4&mc=10456&sn=3008&utm_source=twitter&utm_medium=socialmedia&utm_campaign=iglive2021&utm_content=g5-ta">raytrek G5-TA</a> 写真向けモデル』をもらえるということですよね」<br>
                            <br>
                            齊藤「そうなんです、パソコンを差し上げちゃうんです。今回プレゼントする『<a target="_blank" href="https://www.dospara.co.jp/5shopping/detail_prime.php?tg=4&mc=10456&sn=3008&utm_source=twitter&utm_medium=socialmedia&utm_campaign=iglive2021&utm_content=g5-ta">raytrek G5-TA</a> 写真向けモデル』は、お肌の補正や色味の補正などの軽めのレタッチなどの作業をスムーズに行っていただけるモデルになっています」<br>
                            <br>
                            ※本記事内に登場するハッシュタグ投稿キャンペーンは2021年11月14日まで募集していたものです。現在は募集を終了していますのでご了承ください。<br>
                            <br>
                            塚崎「早速コメントがきていますね。いまの時期、各地で紅葉が見頃ですが、赤色が飽和してしまうなど現像が難しいです」<br>
                            <br>
                            井上「飽和してるってお気づきになっていることが大切な点で、それなら大丈夫だと思います。赤、オレンジ、紫、それぞれの色のごとに輝度や彩度などを調整できますから、色飽和していると思ったらその色だけを特定し、下げてあげるようにすればいいと思います」<br>
                            <br>
                            塚崎「次のコメントは、レタッチのPCで悩んでいます。お手軽なノートPCでお願いします、とのことです」<br>
                            <br>
                            別所「まさにraytrekさんのがいいんじゃないですか」<br>
                            <br>
                            齊藤「性能が高すぎても（スペックを）持て余してしまいますので、今回のキャンペーン賞品である<a target="_blank" href="https://www.dospara.co.jp/5shopping/detail_prime.php?tg=4&mc=10456&sn=3008&utm_source=twitter&utm_medium=socialmedia&utm_campaign=iglive2021&utm_content=g5-ta">raytrek G5-TA</a>はレタッチ専門ということであればおすすめです」<br>
                            <br>
                            塚崎「それではそろそろ写真の紹介に入らせていただきます。まずは別所さんの作品からです」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/01.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            別所「花火の写真の現像自体はシンプルで、輝度を下げたりホワイトバランスを変えたりとかなので、そんなに困ったりはしません。その前に花火ってナマモノなんですね。花火はみんなが見ているじゃないですか。花火を見ている空気感を大事にするために、写真の投稿は花火が終わってから5分以内に行います。だいたい山の上で花火を撮っていることが多く、そこにPCを持っていきます。raytrekの製品もそうですが、ノートPCはそういうときに活躍しますよね。現地で急いで現像をして、ラストで悩むのはトリミングです。花火はプログラムが盛り上がるほどサイズ感が大きくなっていくため、大会の最初の方の花火のサイズで画角を決めていると最後の方にはフレームアウトしてしまいます。フレームアウトすると戻すことはできないですよね。それを回避するためにできるだけ広めに、とはいえ花火が米粒にならない程度で写っているくらいに撮ることが多いです。現像をして最終的に出力した写真がこれです」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/02.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            別所「かなり元画像から変わり、印象も良くなっていると思います。元画像と比べるとわかりますが、ほんの少し花火の右端と左端を切るようにトリミングをしています。なぜかというと、花火の広がりを、写真を見た人が想像できるようにしているからです。これがトリミングの積極的な効果です。仕方なくトリミングをするのではなくて、第3のシャッターとしての役割というか、最後に出力をする時にもう一度シャッターを心の中で切る感覚でトリミングをしています」<br>
                            <br>
                            塚崎「技術力でトリミングなしの完全なフレーミングをするのも素晴らしいと思うのですが、花火は技術力というよりも運じゃないですか。風などによって広がり方は予想がつかないので、そういう意味では広めに撮っておいて、自分が本当に表現したいところでトリミングするのは重要なことだと思います」<br>
                            <br>
                            井上「トリミングをする位置で空間を想像させるというのはとても大事で、僕も雪原の上をキツネがぽつんと歩いて行くときに、その先に木がありましたとか、納屋がありますとか、そういうのがあったら見せないようにして、画面の中には地平線だけというふうにして想像してもらうようにしています」<br>
                            <br>
                            塚崎「見せないことで想像力をかき立てるということですね」<br>
                            <br>
                            別所「花火の現像の時は最後のトリミングに一番悩みます。せっかく撮ったのでやはり全部見せたいのですが、『切る』という決断力ですよね」<br>
                            <br>
                            井上「1回目は現場でシャッターを切る、何枚も撮った写真の中から選ぶという意味で2回目のシャッターを切る、そしてトリミングをする、画角を改めて決め直す、という意味で第3のシャッターを切る。1、2、3のシャッターを切るというのはとても大事なことだと思いますね」<br>
                            <br>
                            塚崎「いまはPCの操作が上手い人が写真が上手いということですよね。とコメントがきています」<br>
                            <br>
                            別所「いや、写真が上手い人は現地で上手いですよね」<br>
                            <br>
                            井上「現場の臨場感を画像でそのまま表現できるという、撮影がすごく上手い人もいるんですよ。でもカメラの性能を最大限に使い切り、そしてより人間の目で見たものに自然に近づけていくという命題を与えるなら、やはりPCの操作が上手くなればなるほどいいのかなと思いますね」<br>
                            <br>
                            別所「いろいろな正解があるんです。現場での撮って出しが上手い人もいれば、PCを使って現像が上手い人もいる。色々な正解があるのが写真だと思っています」<br>
                            <br>
                            塚崎「話が盛り上がってきましたが、次の作品をご紹介していきましょう」<br>
                            <br>
                            齊藤「ハッシュタグを付けてご投稿いただいた作品をご紹介します。ご一緒にご相談もいただきましたので合わせて読み上げさせていただきます。『横から光が入っているのですが、上の青紅葉はかなり暗くなっており持ち上げるのが難しかったです。』とのことですが、これについて井上さん別所さんいかがでしょう」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/03.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            別所「いや、この写真素晴らしいですよ」<br>
                            <br>
                            井上「おそらく気になっているところといえば、青い葉が重なっている部分が暗いけれど、もう少し目では明るく見えていて、それを再現したかったということだと思うんですよね」<br>
                            <br>
                            別所「人間の目は暗いところを引っ張って明るく見せてくれますから」<br>
                            <br>
                            井上「どうしたらいいかというと、緑の暗い部分だけを選択して明るさを取り戻してあげればいいんです。かつてはブラシツールを使って選択した部分を、マスク機能を使用して補正する必要がありましたが、いまは画面の中の緑色を選択し、さらに緑色の中でも明るい部分だけをそこから削除し、残った暗い緑のシャドウを上げてあげるようなことができます」<br>
                            <br>
                            別所「PhotoshopにしてもLightroom Classicにしても機能が上がっているので、個別の部分だけの作業が非常にやりやすくなっています」<br>
                            <br>
                            井上「いまは秋なので、紅葉の写真でも同じようなことが言えると思います。やはり逆光のような場所で葉が透けるように撮ったとしても、暗いところは必ず出てくるので、重なった部分の明るさの取り戻し方というのを少ししてあげるだけで、現場で見たものに近づいていくので現像が楽しくなるかもしれないですね」<br>
                            <br>
                            別所「どこまで自分が見たものに近づけられるかが現像の面白いところでもあるし、悩ましいところでもありますね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/04.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            齊藤「同じ方からの投稿ですかね。『紅葉と御堂の色が同じなので、調整が難しいです。』との質問をいただいています」<br>
                            <br>
                            井上「いい質問ですね。御堂の赤色と紅葉の赤色は、光の種類も違うし赤の方向性も違うと思います。別所さんならどうやって分けて現像しますか？」<br>
                            <br>
                            別所「ライトアップされた紅葉なので、ホワイトバランスを青に寄せることで色が分離する瞬間が出てきます。その分離した瞬間に現像しはじめるかもしれません。ホワイトバランスを青に寄せても御堂は赤いので赤いままだけど、紅葉の色合いはライトアップの光分が減算され、ちょっと違う感じの赤に変わっていくのかな、と思います。井上さんならどうします？」<br>
                            <br>
                            井上「御堂の赤色は見た目のちゃんとした色にしたい。そしてライトアップされた紅葉は結構人為的なところがあるので、居心地がいい、心地がいい色にしたいなというところで、別々に現像したいなと。僕ならレイヤーを切ってマスクを切っちゃうかな。Lightroom Classicだったら赤いところだけを抽出して、他の赤いところは触らないようにするというマスクを作ります。そのときにはリフレクションの部分の現像を忘れないようにしたいですね」<br>
                            <br>
                            塚崎「続いて、質問です。星空が好きで撮影していますがレタッチはスマホでやっています。やはりPCでやった方がいいのでしょうか。とのことですが」<br>
                            <br>
                            別所「星の現像はマシンのパワーがいるのでPCでやった方がいいですね」<br>
                            <br>
                            井上「PCの方が効率いいんですよ。例えばノイズのチェックをするときも、スマートフォンや小さなタブレットでやっていると、ノイズがあるかどうかはピンチインして見ていかないといけない。PCでやるとかなり見たままで分かりますから」<br>
                            <br>
                            別所「星はPhotoshopの処理も前提になってくるので、レイヤーの枚数が増えていくとなると、スマートフォンだと厳しいかもしれないです」<br>
                            <br>
                            塚崎「続いては、井上さんのBefore & After作品です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/05.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「排水溝の中を寝ぐらにしていた小キツネを撮った写真です。カメラだけを沈めて撮ったのですが、こうやって撮ると何が問題になるかというと、排水溝の上の部分に直射日光があたっていてものすごく明るいんです。でも排水溝の中は日陰ですから、人間の目で見るともっともっと見えていたし、こんなに青くなかったんです。これを僕が見た目に近づけるとどうなるかというと…」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/06.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「だいぶ変わりましたよね。どういうことに気をつけるかというと、シャドウを持ち上げると、日陰の部分の青みが残るんです。この青みをちゃんと取ってあげる。この作業がすごく大切なことです。あとは、撮影のときに完璧な露出で撮ろうと思ってはいけない。カメラの性能はとても高く、特にシャドウの中にたくさん色や明るさなどの情報などが残っています。白く飛んだところはもう戻ってこないので飛ばないように暗めに撮る。そして PC で自分の見た目に戻してあげる。こういうレタッチをすると、より自然な仕上がりになるかなと思います」<br>
                            <br>
                            別所「Beforeはキツネが青みがかっているのが見えますね」<br>
                            <br>
                            井上「これがアウトプットされてくると、カメラを使って撮ったという科学的には自然で正解だったとしても、人間の目で見たものとしては異様なんです」<br>
                            <br>
                            塚崎「影は青いんですよね。科学的にカメラは正しいから青く撮れますが、人間の目って色味の補正をかけるから青くは見えない。だから、変に見えるということですよね」<br>
                            <br>
                            井上「キツネの体毛のふわふわ感、というコメントがきていますね。これも大事です。ピントが合ったところをシャープに仕上げたいという気持ちはあるのですが、そうやると毛がゴワゴワしてしまいます。ふわふわさせるためにはシャープネスを下げたり、明瞭度を下げたりしたほうがいいかもしれません」<br>
                            <br>
                            塚崎「質問がきています。PCのスペックはどの程度必要でしょうか」<br>
                            <br>
                            井上「写真の現像だけでいうなら、Core i5やCore i7がいいと思いますが、自分が PC にかけられるコストとカメラにかけられるコスト、そして撮影に行くためのコストのバランスだと思います。Core i5あたりから始めるのは良い手かもしれないですね。」<br>
                            <br>
                            別所「ちょうど今回のキャンペーンで当たる『<a target="_blank" href="https://www.dospara.co.jp/5shopping/detail_prime.php?tg=4&mc=10456&sn=3008&utm_source=twitter&utm_medium=socialmedia&utm_campaign=iglive2021&utm_content=g5-ta">raytrek G5-TA</a>』なんかちょうどいいんじゃないですか」<br>
                            <br>
                            井上「Core i5のPCは初めてレタッチをする方にはちょうど良さそうですね」<br>
                            <br>
                            塚崎「では次の写真です。別所さんの作品ですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/07.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            別所「井上さんの前で雪の写真を出すのは正直迷ったのですが。現像自体は凝ったことはしていません。リフレクションの所の輝度を印象的に仕上げました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/08.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            別所「SNSに最初にアップしたのがこの写真です。メタセコイアに雪が乗っているので暖かみがあるんですよね。メタセコイアの色をちゃんと写真に残しておきたいなと思ったのでこの現像にしました。ただ最近、最終出力を変えたんです。それが次の写真です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/09.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            別所「今日のコメントでも『スマホではなくPCで現像したほうがいいでしょうか』などの質問をいただくように、最近は最初に写真を見ていただく主戦場はデジタルデバイスになっています。最終的にはプリントにしたいと思いつつも最初はデジタルになってしまう。そのときにデジタルデバイスってみんな違うんですよ。スマートフォンひとつとっても彩度から色味から全部違う。PCもその差はもっと大きくて、ちゃんとキャリブレーションされたモニターを使っている人もいれば、あらゆるところで色味と明るさの違いが出てくることもあります。このときに、写真の彩度やカラーバランスが偏った状態で現像をすると、見る人のデバイスによってはより偏って見えてしまう場合があるんです。ですから、最近は最終出力をニュートラルな方向へ落ち着かせることが多いですね」<br>
                            <br>
                            井上「家電量販店に行くと、テレビの画面が並んでいますよね。大体同じような色に合わせているものの、近づいてみると違ったりするんです。みんな正解を見ているわけではないから僕は『SNSセーフカラー』といって、白を白く出すのならこの辺りに置くのがいいのかな、みたいなことを気にしています。また、広告の写真を撮るときも、企業のロゴが入りますから、ロゴの色はみんなのモニターにある程度正しく写るようにしてあげて出すということを気にします」<br>
                            <br>
                            塚崎「いまは有機ELディスプレイもありますから、より色はデバイスによって変わりますよね」<br>
                            <br>
                            井上「有機ELの場合は黒が潰れますから、ちゃんとそれを意識してデータを作らないといけないんです。コメントでも、白をうまく出す方法はありますか？ときていますね。強調してメリハリをよくつけることです。ふわっとしたグラデーションがいいなというのは、上級者です。まずはしっかり見せたい部分を丁寧に作り込んでいって、白は少し強調するぐらいがいいと思います」<br>
                            <br>
                            塚崎「何かを生み出すなら断然 PC の方がいいですね、というコメントもありますね」<br>
                            <br>
                            別所「スマートフォンやタブレットのレタッチをしていると、自分が思っている出力とPCを使っている人の出力に大きな差が出たりするので、やはりPC でカラーキャリブレーションをしたディスプレイを使いレタッチするのがいいと思います」<br>
                            <br>
                            井上「コントラストの増減というようなコメントが見えましたが、コントラストを触っていったとき、スマートフォンだと環境光が入ったり画面が小さいため、コントラストが変わっていくのを見るのは PC の大きなディスプレイの方がいいかもしれないですね」<br>
                            <br>
                            塚崎「 PCで見たときとスマホで見たときの色味の違いの問題は、皆さんはどうやって解決していますか。PCで現像した後にスマホで確認をしますか、とコメントがきています」<br>
                            <br>
                            別所「それはもちろんやりますね。皆さんが一番使っているであろうスマホで最終確認は必ずします」<br>
                            <br>
                            井上「あと小さい画面にぎゅっと色や明るさが詰まるので、スマートフォンでは少し暗く見えるんですよ」<br>
                            <br>
                            塚崎「ありがとうございます。では次の作品をご紹介しましょう」<br>
                            <br>
                            齊藤「こちらはハッシュタグキャンペーンでご投稿いただいた写真です。いかがでしょうか」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/10.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「僕が少し気になったのは。手前の雲の色温度と奥の方の雲の色温度が少しずれている点ですね」<br>
                            <br>
                            別所「手前が青っぽく。奥が赤っぽいですよね」<br>
                            <br>
                            井上「もしかすると。手前の明るさを取り戻せたら画面全体のバランスが良くなるかもしれません」<br>
                            <br>
                            別所「真ん中にある雪を見せたかったのかなと思いました。敢えて画面の中央に位置しているので。これを視点のポイントにしているはずです。そこの輝度を少し上げるといいかもしれません」<br>
                            <br>
                            塚崎「今のままでも十分素敵な作品ですよね。では、続いて井上さんのBefore & After作品を拝見したいと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/11.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「リスの写真です。少し暗いと思われるかもしれません。リスが僕の前を走っていったんですよね。それを慌てて撮ったんですが、走っているリスを撮るときにはシャッタースピードを1/1250秒、1/1600秒、1/2000秒とかなり速くします。ISOは1600〜2000までと決めていて、そのままで撮ると暗く写るんです。でも暗くてもいいんですよ。現像するとここまで取り戻せます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_raytrek/12.jpg" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「このように、すごく明るい森なんです。でもシャッタースピードを速くしてISOを低くすれば暗く写ってしまうんです。また、背景のガサガサしたところを見えなくするためにトリミングしています。ちなみにこれは秒間20コマの連写をしています。連写をしているのでリスが葉っぱを巻き上げていることなんて想像もしていない。一生懸命連写をしたあとで、そのデータを超高速で読み込むには、良いPCがないとできません。それを Lightroom Classic上でカーソルキーを連打して超高速で見ていくんです。いいなと思ったら採用という意味でAを押します。これが僕にとっての2回目のシャッターです。その後でトリミングするという第3のシャッター。この一連の作業をやるには高性能のPCじゃないと厳しいですね」<br>
                            <br>
                            塚崎「よく、連写しすぎるとPCで見るのが辛いから撮影枚数を減らす、という方もいますよね」<br>
                            <br>
                            井上「せっかくいい場所に行っているのに、惜しいですよね。枚数を減らして撮れる人はいいですが、撮れない場合もありますから。僕は愚直に連写します。raytrekで販売している別所さんモデルのPCは10ギガビットEthernet<sup>（※1）</sup>、僕のモデルのPCはThunderbolt&trade; 3<sup>（※2）</sup>がついているので、こういった転送速度の速いPCで転送をかけると、早くセレクトができるようになりますよ」<br>
                            <span class="smaller">※1 東京カメラ部10選 別所隆弘監修モデル raytrek ZG とraytrek ZV のみ搭載<br>
                            ※2 東京カメラ部10選 井上浩輝監修モデル raytrek ZG とraytrek ZV のみ搭載</span><br>
                            <br>
                            塚崎「ここでまたコメントのご紹介です。編集ではどの操作に一番時間をかけていますか」<br>
                            <br>
                            井上「色作りかなぁ」<br>
                            <br>
                            別所「僕も色です」<br>
                            <br>
                            塚崎「レタッチで暗い雰囲気にする場合どの点に気をつけますか、と質問もきています」<br>
                            <br>
                            別所「黒つぶれをしないように考えていますね。やっぱり階調を維持する黒にしたいです。データ上ではつぶれていなかったとしても、潰れているように見えてしまってはもったいないなと思います。暗いのも大切にしつつ階調が見える方向で現像します」<br>
                            <br>
                            井上「 僕も全く同じです。暗いところの階調を完全に潰さないようにする。何か見えてるんじゃないかなという“かすみ感”を作るように気をつけています」<br>
                            <br>
                            塚崎「外出先でスマートフォンで現像しなければいけないときは、何に気をつければいいですか、とコメントがきています」<br>
                            <br>
                            井上「僕はジャンパーをかぶったり、LEDの光源や、太陽光のない屋内で現像するようにします。また自分のスマホで現像するときは画面の明るさをいつも同じ、75％とか80％にとどめて作業するということにも気をつけています」<br>
                            <br>
                            塚崎「そろそろ時間も迫ってまいりましたので、最後に皆さんからコメントをお願いします。まずは別所さんからです」<br>
                            <br>
                            別所「僕は大学で講義をおこなっているのですが、学生によく質問されるのがカメラの次に何を買ったらいいかということ。まず話すのは、現像ができるいいPCを買えということです。それが君のカメラライフをより豊かにするから、レンズを買いたい気持ちはわかるけれど、とりあえず買える範囲でPCを買って欲しいですね。そう考えると、raytrekのG5-TAは学生にも買いやすい価格ですし、授業にも持っていけますからおすすめです」<br>
                            <br>
                            塚崎「ありがとうございます。続いて井上さんお願いします」<br>
                            <br>
                            井上「僕は幸いにも高性能なカメラを使う環境にあり、そのカメラの性能を生かすためには、高性能のPCも必要なんです。そこそこのカメラの場合ではどうかというと、そこそこのPCではなく、やはり高性能のPCが必要なんです。なぜなら、いいカメラはものすごくよく写るため、少し現像をすればキレイなんです。でも、あまり性能のよくないカメラで撮ると、いろいろな点で限界があるんですよ。例えばいいカメラだったらISO3200で撮影できるのに、そうでもないカメラだったらISO800までしか撮れない。ものすごく暗く写りますよ。これをいかに違和感なく、ノイズ感なくきれいに見せるかとなったら、すごくハードな現像が必要になるんですよね。そのときに やはりPCのパワーは必要ですね。性能の低いカメラであればあるほど反比例して、PCが高性能であるといいかもしれないですね。」<br>
                            <br>
                            塚崎「カメラが撮るRAWをJPEGに変換するのはカメラの中でやるわけで、どうしてもカメラの本体のCPUや電池に左右されます。その進歩に比べるとPCの進歩の方が速いので、PCを使えると、CPUの部分は未来のカメラを使っているのと同じだと思います。未来のものが必要だという方は投資してもいいのかもしれないですね。では、最後に齊藤さんコメントをお願いします」<br>
                            <br>
                            齊藤「素敵な機会をありがとうございました。私たちraytrekはクリエイター向けのPCを展開しており、ブランドサイト『raytrek.net』ではおすすめPC診断を展開しております。ご自身で使われているカメラや、具体的な操作内容に関する質問に答えていただきますと、おすすめのPCがわかります」<br>
                            <br>
                            井上「もしわからなければ、僕か別所さんのモデルを選べば間違いないです」<br>
                            <br>
                            齊藤「開催中のキャンペーンで当たる『<a target="_blank" href="https://www.dospara.co.jp/5shopping/detail_prime.php?tg=4&mc=10456&sn=3008&utm_source=twitter&utm_medium=socialmedia&utm_campaign=iglive2021&utm_content=g5-ta">raytrek G5-TA</a>』というモデルは、インテルのCore i5というCPUを搭載しており、色味の補正や肌のレタッチなど、軽めのレタッチ、主にLightroom Classicでの現像される方におすすめになっています。メモリも16 GB搭載しておりスムーズに作動しながらも、価格は税込で109,800円となっております。画面もノングレアで目に優しいモデルです。ぜひ調べてみてください」<br>
                            <br>
                            塚崎「本日はさまざまなコメントをいただきありがとうございます。東京カメラ部Instagramの動画一覧や YouTubeチャンネルにもアーカイブを掲載しておりますのでぜひご覧ください。本日はありがとうございました」<br>
                            <br>
                            <br>
                            ※本記事内に登場するハッシュタグ投稿キャンペーンは2021年11月14日まで募集していたものです。現在は募集を終了していますのでご了承ください。<br>
                            ※Adobe、PhotoshopならびにLightroomはAdobe Systems Incorporated（アドビシステムズ社）の米国ならびにその他の国における登録商標または商標です。<br>
                            ※Thunderbolt&trade; 3 は、Intel Corporationまたはその関連会社の商標です。<br>
                            ※その他記載されている社名・商品名・サービス名などは、それぞれ各社が商標として利用している場合があります。
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="movBlock">
                    <div class="inner4">
                        <h2>このレポートのアーカイブ動画</h2>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/Co9wxxUW5ZM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div><!-- /inner4-->
                </section><!-- /movBlock-->

                <section class="bnrBlock2">
                    <div class="inner4">
                        <a target="_blank" href="https://raytrek.net/"><picture><source media="(max-width:640px)" srcset="/img_report_raytrek/bnr_raytrek_sp.png"><img src="/img_report_raytrek/bnr_raytrek.png" alt="raytrek ブランドサイトはこちら"></picture></a>
                        <a target="_blank" href="https://raytrek.tokyocameraclub.com/oshanpotocontest2021/"><picture><source media="(max-width:640px)" srcset="/img_report_raytrek/bnr_contest_sp.jpg"/><img src="/img_report_raytrek/bnr_contest.jpg" alt="”お写んぽと”コンテストはこちら"></picture></a>
                    </div>
                </section><!-- /bnrBlock2-->
                <section class="bnrBlock1">
                    <div class="inner4">
                        <a target="_blank" href="https://raytrek.net/visual/recommendation/"><img src="/img_report_raytrek/bnr_recommend.jpg" alt="raytrek おすすめPC診断"></a>
                    </div><!-- /inner4-->
                </section><!-- /bnrBlock1-->

                <section class="btnBlock">
                    <div class="inner4">
                      <router-link to="/events/archives" class="StandardBtn">主催者公式イベントアーカイブ</router-link>
                    </div><!-- /inner4-->
                </section><!-- /btnBlock-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->

    <Footer />
    <UpButton />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}

</style>
